import { QuarterCloseChecklistRowSections } from '@shared/store/workflow/workflow-types';
import { Workflow } from '@shared/store/workflow/workflow.store';

export function confirmForecastSectionCompleted(workflowList: Workflow[]): boolean {
  const confirmForecastSection = workflowList.filter((workflow) => {
    const section = Object.values(QuarterCloseChecklistRowSections).find(
      (workflowSection) => workflowSection === 'ConfirmForecast'
    );

    return workflow.section === section;
  });

  return confirmForecastSection.every((worklow) => worklow.properties.locked);
}
